import MedicationQuestion from "./MedicationQuestion"
import MedicationStringCreator, {
    resolveString
} from "./MedicationStringCreator"
import MedicationQuestionnaireInput from "./MedicationQuestionnaireInput"
import notNull from "../../util/notNull"
import expect from "../../util/expect"
import unique from "../../util/unique"
import { MedicationIndicators } from "pokal_api"

class MedicationAnswer {
    private info: MedicationQuestionnaireInput | null
    private answerCreator: MedicationStringCreator
    private next: MedicationQuestion | null
    private indicators: MedicationIndicators[]
    private indicatorsWithArgs: {
        indicator: MedicationIndicators
        args: string[]
    }[]
    private terminating: boolean
    private problematicATCs: string[]

    constructor(answer: MedicationStringCreator) {
        this.problematicATCs = []
        this.answerCreator = answer
        this.next = null
        this.indicators = []
        this.indicatorsWithArgs = []
        this.terminating = false
        this.info = null
    }

    addProblematicACTs(atc: string | string[]) {
        if (Array.isArray(atc)) this.problematicATCs.push(...atc)
        else this.problematicATCs.push(atc)
        this.problematicATCs = unique(this.problematicATCs)
        return this.pushACTsToChildren()
    }

    pushACTsToChildren() {
        if (this.next) this.next.addProblematicACTs(this.problematicATCs)
        return this
    }

    getProblematicACTs() {
        return this.problematicATCs
    }

    inject(info: MedicationQuestionnaireInput): this {
        this.info = info
        return this
    }

    followedBy(question?: MedicationQuestion): this {
        if (question) this.next = question
        return this
    }

    getFollowingQuestion(): MedicationQuestion | null {
        return this.next
    }

    hasFollowingQuestion(): boolean {
        return notNull(this.next)
    }

    expectFollowingQuestion(): MedicationQuestion {
        return expect(this.next)
    }

    triggers(indicators: MedicationIndicators[]): this {
        this.indicators = indicators
        return this
    }

    triggersIndicatorWithArgs(
        indicator: MedicationIndicators,
        args: string[]
    ): this {
        this.indicatorsWithArgs.push({ indicator: indicator, args })
        return this
    }

    terminates(): this {
        this.terminating = true
        return this
    }

    isFinalAnswer(): boolean {
        return this.terminating
    }

    get(): string {
        return resolveString(this.answerCreator, expect(this.info))
    }

    getTriggeredIndicators(): {
        withoutArgs: MedicationIndicators[]
        withArgs: { indicator: MedicationIndicators; args: string[] }[]
    } {
        return {
            withoutArgs: this.indicators,
            withArgs: this.indicatorsWithArgs
        }
    }
}

export default MedicationAnswer
